
import Scrollbar from 'smooth-scrollbar';

'use strict'

class CustomSelect{
    constructor(select){
        this._wrapper = select.parentNode;
        this._select = select;
        
        this._isOpen = false;

        /*create a new DIV that will act as the selected item:*/
        this._selected = document.createElement("div");
        this._selected.setAttribute("class", "select-selected");
        this._selected.innerHTML = this._select.options[this._select.selectedIndex].innerHTML;
        this._wrapper.appendChild(this._selected);
        /*for each element, create a new DIV that will contain the option list:*/
        this._holderOptions = document.createElement("DIV");
        this._holderOptions.setAttribute("class", "select-items select-hide");
        
        this._options = [];    

        for (let j = 0; j < this._select.length; j++) {
            /*for each option in the original select element,
            create a new DIV that will act as an option item:*/
            let option = document.createElement("DIV");
            option.innerHTML = this._select.options[j].innerHTML;
            option.addEventListener("click", (e) => {
                this._selectOptionByText(e.currentTarget.innerHTML);                
            });
            this._options.push(option);
            this._holderOptions.appendChild(option);
        }
        
        this._wrapper.appendChild(this._holderOptions);
        this._selected.addEventListener("click", (e) => {
            /*when the select box is clicked, close any other select boxes,
            and open/close the current select box:*/
            e.stopPropagation();
            
            this._closeAllSelect(this._select);
            this._holderOptions.classList.toggle("select-hide");
            this._selected.classList.toggle("select-arrow-active");
        });


        this._timeout = null;
        this._search = '';

        this._scrollbar = Scrollbar.init(this._wrapper.querySelector('.select-items'));
      
        
        document.addEventListener("click", this._closeAllSelect.bind(this));
        this._select.addEventListener("change", this._onSelectChange.bind(this));
        //document.addEventListener("keydown", this._onKeyDown.bind(this));
        
    }

    /* _onKeyDown(e){
        //console.log(e.keyCode);
        if(!this._holderOptions.classList.contains('select-hide')){
            if(e.keyCode == 13 || e.keyCode == 27){
                this._holderOptions.classList.add("select-hide");
            }else{
                clearTimeout(this._timeout);
            
                this._search += String.fromCharCode(e.keyCode);

                for (let i = 0; i < this._select.options.length; i++) {
                
                    if(this._select.options[i].text.substring(0, this._search.length).toLowerCase() ==  this._search.toLowerCase()){
                        this._scrollbar.scrollTo(this._options[i].offsetTop, 1000);
                        this._selectOptionByText(this._select.options[i].text);
                        break;
                    }
                }

                this._timeout = setTimeout(this._onTimeoutSearch.bind(this), 300);
            }
        }      
        
    } */

    _onTimeoutSearch(){
        this._search = '';
    }

    _selectOptionByText(text){
        for (let i = 0; i < this._select.options.length; i++) {
            if (this._select.options[i].innerHTML == text) {
                this._select.selectedIndex = i;
                this._selected.innerHTML = text;
                this._options[i].setAttribute("class", "selected");
            }else{
                this._options[i].removeAttribute("class");
            }
        }

        this._select.dispatchEvent(new Event('change'));
        this._selected.click();
    }

    _closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
        except the current select box:*/
        var x, y, i, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }

    get hasSelection(){
        return this._select.selectedIndex != 0;
    }

    set error(error){
        if(error){
            this._wrapper.parentNode.classList.add('form__group--error');
        }else{
            this._wrapper.parentNode.classList.remove('form__group--error');
        }
    }
    
    _onSelectChange(e){
        if(this._select.selectedIndex == 0){
            this._wrapper.parentNode.classList.remove('filled');
        }else{
            this._wrapper.parentNode.classList.add('filled');
        }
    }

    reset(){
        this._select.selectedIndex = 0;
        this._wrapper.querySelector('.select-selected').innerHTML = this._select.options[0].text;
        
        let optionSelected = this._wrapper.querySelector('.select-items .selected');
        if(optionSelected){
            optionSelected.classList.remove('selected');
        }
                
        this._wrapper.parentNode.classList.remove('filled');
        this.error = false;

        this._select.dispatchEvent(new CustomEvent('change', {detail:{type:'reset'}}));
        this._closeAllSelect();
    }

    get value(){
        return this._select.value;
    }

    get selectedIndex(){
        return this._select.selectedIndex;
    }
    
    addEventListener(event, callback){
        this._select.addEventListener(event, callback);
    }

}

export default CustomSelect;